export default "__VITE_ASSET__C_vsxYy6__"